/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ci_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspect Unicode chars`)
};

const es_ci_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspecciona caracteres Unicode`)
};

const de_ci_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unicode-Zeichen untersuchen`)
};

const nl_ci_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unicode-karakters controleren`)
};

const fr_ci_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspecter les caractères Unicode`)
};

const it_ci_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ispeziona caratteri Unicode`)
};

const pt_br2_ci_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspecione caracteres Unicode`)
};

const pt_ci_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspecionar caracteres Unicode`)
};

const ja_ci_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`「Unicode 文字を調べる」`)
};

const zh_ci_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`检查 Unicode 字符`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ci_nav_main_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ci_nav_main_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ci_nav_main_desc", locale)
	if (locale === "en") return en_ci_nav_main_desc(inputs)
	if (locale === "es") return es_ci_nav_main_desc(inputs)
	if (locale === "de") return de_ci_nav_main_desc(inputs)
	if (locale === "nl") return nl_ci_nav_main_desc(inputs)
	if (locale === "fr") return fr_ci_nav_main_desc(inputs)
	if (locale === "it") return it_ci_nav_main_desc(inputs)
	if (locale === "pt-BR") return pt_br2_ci_nav_main_desc(inputs)
	if (locale === "pt") return pt_ci_nav_main_desc(inputs)
	if (locale === "ja") return ja_ci_nav_main_desc(inputs)
	return zh_ci_nav_main_desc(inputs)
};